window.Paths = {
    FOLDER_ROBOTS: window.Settings.LOCAL_BUILD
        ? "Sources/Robots/files/"
        : "/robot/",
    FOLDER_ROBOTS_IMG: window.Settings.LOCAL_BUILD
        ? "Sources/Robots/files/"
        : "/robot/img/",

    FOLDER_AXES: window.Settings.LOCAL_BUILD
        ? "Sources/Axes/files/"
        : "/robot/",
    FOLDER_AXES_IMG: window.Settings.LOCAL_BUILD
        ? "Sources/Axes/files/"
        : "/robot/img/",

    FOLDER_MECHANISMS: window.Settings.LOCAL_BUILD
        ? "Sources/Mechanisms/files/"
        : "/robotlib/tools/",
    FOLDER_MECHANISMS_IMG: window.Settings.LOCAL_BUILD
        ? "Sources/Mechanisms/files/"
        : "/robotlib/tools/",

    FOLDER_TOOLS: window.Settings.LOCAL_BUILD
        ? "Sources/Tools/files/"
        : "/robotlib/tools/",
    FOLDER_TOOLS_IMG: window.Settings.LOCAL_BUILD
        ? "Sources/Tools/files/"
        : "/robotlib/tools/",

    FOLDER_OBJECTS: window.Settings.LOCAL_BUILD
        ? "Sources/Objects/files/"
        : "/robotlib/tools/",
    FOLDER_OBJECTS_IMG: window.Settings.LOCAL_BUILD
        ? "Sources/Objects/files/"
        : "/robotlib/tools/",

    FOLDER_STATIONS: window.Settings.LOCAL_BUILD
        ? "Sources/Stations/files/"
        : "/library-stations/lib/",
    FOLDER_STATIONS_IMG: window.Settings.LOCAL_BUILD
        ? "Sources/Stations/files/"
        : "/library-stations/lib/img/",

    FOLDER_ADDINS: window.Settings.LOCAL_BUILD
        ? "Sources/Addins/files/"
        : "/library-addins/lib/",
    FOLDER_ADDINS_IMG: window.Settings.LOCAL_BUILD
        ? "Sources/Addins/files/"
        : "/library-addins/lib/img/",

    LIB_ASSETS: window.Settings.LOCAL_BUILD
        ? "RoboDK%20Web%20Library/lib_assets/"
        : "lib_assets/",
    DOMAIN: (window.Settings.LOCAL_BUILD)
        ? ";domain=localhost"
        : ";domain=.robodk.com",
    DETAILS_URL: (window.Settings.LOCAL_BUILD)
        ? "http://localhost:3003/?"
        : "/library-details/item-details?",

    /*
    ROBODK_WEB_LINK: "/web/index.html",
    ROBODK_WEB_OPEN: "/web/index.html?-OpenURL=//web.robodk.com",
    ROBODK_WEB_EMBED: "/web/index.html?--Embedded&-OpenURL=//web.robodk.com/",
    */
    ROBODK_WEB_LINK: "//web.robodk.com/web",
    ROBODK_WEB_OPEN: "//web.robodk.com/web?-OpenURL=//web.robodk.com",
    ROBODK_WEB_EMBED: "//web.robodk.com/index2.html?--Embedded&-OpenURL=//web.robodk.com/",
};
